import React from 'react'
import BlogsList from '../components/Blogs/BlogsList.component'
import Footer1 from '../components/Footers/Footer1.component'
import Header from '../components/Headers/Header.component'

export default function Blogs() {
    return (
        <>
            <Header />

            <main className="tk-bg">
                {/* <!-- SERVICES START --> */}
                <section className="tk-main-section">
                <BlogsList />
                </section>
                {/* <!-- SERVICES END --> */}
            </main>

            <Footer1 />
        </>
    )
}
